module.exports = __webpack_public_path__ + "img/2026-05-03a_1.385d6c52.jpg";